var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { alignItems, display, flexWrap, maxWidth } from 'styled-system';
import { GridItem } from '../../common/components/Grid';
import NewsletterSignupInput from '../../common/components/NewsletterSignupInput';
import { NewsletterContainer, } from './NewsletterContainer';
import { NewsletterContent } from './NewsletterContent';
var InputContainerGrid = styled(GridItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), display, alignItems, flexWrap);
InputContainerGrid.defaultProps = {
    w: [1, 6 / 8, 5 / 12],
    pt: ['sp_8', null, 'sp_0'],
    pr: ['sp_8', 'sp_12', 'sp_0'],
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
};
var EmailField = styled(NewsletterSignupInput)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), maxWidth);
EmailField.defaultProps = {
    maxWidth: '383px',
};
export var NewsletterSignup = function (_a) {
    var voucher = _a.voucher, headline = _a.headline, subline = _a.subline, asteriskText = _a.asteriskText, tracking = _a.tracking, textColor = _a.textColor, icon = _a.icon, buttonKind = _a.buttonKind, containerProps = __rest(_a, ["voucher", "headline", "subline", "asteriskText", "tracking", "textColor", "icon", "buttonKind"]);
    return (React.createElement(NewsletterContainer, __assign({}, containerProps),
        React.createElement(NewsletterContent, { icon: icon, voucher: voucher, headline: headline, subline: subline, asteriskText: asteriskText, textColor: textColor }),
        React.createElement(InputContainerGrid, null,
            React.createElement(EmailField, { tracking: tracking, buttonKind: buttonKind }))));
};
NewsletterSignup.defaultProps = {
    __legacy_shop_reboot_max_width: true,
    textColor: 'text',
    voucher: {
        amount: '20',
        currency: '€',
        label: 'Gutschein',
    },
};
export default NewsletterSignup;
var templateObject_1, templateObject_2;
